<template>
    <div class="kgr-inputGroup min-height">
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Auswertung') }}
        </h3>

        <kgr-form-row
            :label="$t('Start')"
            :error="error"
            :inline="true"
            field-name="start"
        >
            <kgr-date-picker
                v-model="start"
                @post-input="showSales()"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Ende')"
            :error="error"
            :inline="true"
            field-name="end"
        >
            <kgr-date-picker
                v-model="end"
                @post-input="showSales()"
            />
        </kgr-form-row>
        <kgr-form-row
            v-if="canSeeEmployees"
            :label="$t('Mitarbeiter')"
            :error="error"
            :inline="true"
            field-name="employee"
        >
            <kgr-club-employee-select
                v-model="clubEmployee"
                :club-id="clubId"
                hide-label
                @post-input="showSales()"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Zahlungsmethode')"
            :error="error"
            :inline="true"
            field-name="paymentMethod"
        >
            <kgr-select
                v-model="paymentMethod"
                :options="paymentMethods"
                display="label"
                @post-input="showSales()"
            />
        </kgr-form-row>
        <br /><br />

        <kgr-button
            :value="$t('Verkäufe anzeigen')"
            :disabled="buttonDisabled"
            :pending="pending"
            @click="showSales()"
        />

        <kgr-button
            :value="$t('CSV-Export')"
            :disabled="buttonDisabled"
            :pending="pendingExport"
            class="exportButton"
            @click="exportCsv()"
        />

        <hr class="kgr-separator" />

        <kgr-sales-list-evaluation-table
            :member-club-fees="memberClubFees"
        />
    </div>
</template>

<script>
import { format, parse } from '@legacy/js/date/date-fns.js';
import ClubEmployeesSelect from '../../common/form/select/ClubEmployeesSelect.vue';
import ClubSalesListEvaluationTable from './ClubSalesListEvaluationTable.vue';
import ClubSalesListExportRepository from '../../../js/repository/ClubSalesListExportRepository.js';
import ClubSalesListMemberClubFeeRepository from '../../../js/repository/ClubSalesListMemberClubFeeRepository.js';
import DatePicker from '../../common/form/picker/DatePicker.vue';
import Error from '../../../js/model/Error.js';
import FormRow from '../../common/form/FormRow.vue';
import GenericSelect from '../../common/form/select/GenericSelect.vue';
import KgrButton from '../../common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-date-picker': DatePicker,
        'kgr-button': KgrButton,
        'kgr-sales-list-evaluation-table': ClubSalesListEvaluationTable,
        'kgr-club-employee-select': ClubEmployeesSelect,
        'kgr-select': GenericSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        paymentMethods: {
            type: Array,
            required: true,
        },
        canSeeEmployees: {
            type: Boolean,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            start: format(new Date(), 'dd.MM.yyyy'),
            end: format(new Date(), 'dd.MM.yyyy'),
            memberClubFees: null,
            pending: false,
            pendingExport: false,
            clubEmployee: null,
            paymentMethod: null,
        }
    },
    computed: {
        buttonDisabled() {
            return !this.isValidDate(this.start)
                || !this.isValidDate(this.end)
                || this.getDateFromString(this.start) > this.getDateFromString(this.end);
        },
        query() {
            const start = parse(this.start, 'dd.MM.yyyy', new Date());
            const end = parse(this.end, 'dd.MM.yyyy', new Date());
            return '?dateRange=' + format(start, 'yyyy-MM-dd') +  ':'
                + format(end, 'yyyy-MM-dd')
                + '&userId=' + (null !== this.clubEmployee ? this.clubEmployee.id : '')
                + '&paymentMethod=' + (null !== this.paymentMethod ? this.paymentMethod.value : '');
        },
    },
    mounted() {
        this.showSales();
    },
    methods: {
        showSales() {
            this.pending = true;
            ClubSalesListMemberClubFeeRepository.findByClubIdAndFilters(this.clubId, this.query)
                .then(response => this.memberClubFees = response)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pending = false);
        },
        isValidDate(date) {
            return new RegExp('^([0-2][0-9]|(3)[0-1])(\\.)(((0)[0-9])|((1)[0-2]))(\\.)\\d{4}$').test(date);
        },
        getDateFromString(dateString) {
            return new Date(dateString.replace(/(\d{2})\.(\d{2})\.(\d{4})/,'$3-$2-$1'));
        },
        exportCsv() {
            this.pendingExport = true;
            ClubSalesListExportRepository.getCsvByClubIdAndQuery(this.clubId, this.query)
                .then(() => {})
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pendingExport = false);
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.datepicker {
    width: 100px;
}
.exportButton {
    margin-left: 20px;
}
</style>
